import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateTravelPreferences as updateTravelPreferencesApi } from 'tripPlanner/api'
import { invalidateTrip } from './common'
import type { TravelMode } from 'tripPlanner/api/routes/getRouteInfo'

export const useUpdateTravelPreferences = (
  itemId: string,
  tripId: string,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async(params: { travelPreference?: TravelMode, fromHotelTravelPreference?: TravelMode }): Promise<any> => {
      if (!itemId) {
        return undefined
      }

      const response = await updateTravelPreferencesApi({
        itemId,
        travelPreferences: params.travelPreference,
        fromHotelTravelPreferences: params.fromHotelTravelPreference,
      })
      return response
    },
    onSuccess: () => {
      invalidateTrip(queryClient, tripId)
    },
  })
}
